import { useCallback, useState } from 'react'
import { sileo } from 'sileo'
import ticketService from '../services/ticketService'

/**
 * Transferencia de un ticket a otra cola de atención, con sus avisos.
 *
 * @param {number|string} ticketId
 * @param {(changes: {queueId: number, responsibleId: string|null}) => void} onTransferred
 *   Recibe los datos nuevos del ticket para reflejarlos en pantalla.
 * @returns {{ transfer: (queue: Object, reassign: boolean) => Promise<boolean>, transferring: boolean }}
 */
export default function useQueueTransfer(ticketId, onTransferred) {
  const [transferring, setTransferring] = useState(false)

  const transfer = useCallback(
    async (queue, reassign) => {
      setTransferring(true)
      const { success, data, error } = await ticketService.transferToQueue(
        ticketId,
        queue.id,
        reassign
      )
      setTransferring(false)

      if (!success) {
        sileo.error({ title: 'No se pudo transferir', description: error })
        return false
      }

      onTransferred?.({
        queueId: data.queueId,
        responsibleId: data.responsibleId,
      })
      sileo.success({
        title: `Ticket enviado a «${queue.name}»`,
        description:
          reassign && !data.reassigned
            ? 'La cola no tiene miembros activos: se mantuvo el responsable.'
            : undefined,
      })
      return true
    },
    [ticketId, onTransferred]
  )

  return { transfer, transferring }
}
